<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      field-name="사업장명"
      :date="form.date"
      :typeslabel="{
        date: '계획일',
      }"
    />

<!--    건강상담 일정-->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="건강상담 일정"
      :tableData="[
        { id: 'input1', title: '상담구분', type: 'text', placeholder: '입력' },
        { id: 'input2', title: '시간', type: 'period', width: '340px', },
        { id: 'input3', title: '소속명(부서명)', type: 'text', placeholder: '입력' },
        // { id: 'input4', title: '직급/직책', type: 'text', placeholder: '입력' },
        // { id: 'input5', title: '성명', type: 'text', placeholder: '입력' },
        // { id: 'input6', title: '연락처', type: 'text', placeholder: '입력' },
        { id: 'input7', title: '내용', type: 'text', placeholder: '입력' },
      ]"
      v-model="form.consulting"
      @input="changeTable"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import VueCookie from 'vue-cookie'

export default {
  components: {
    TableCustom,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  created () {
    this.form.date = VueCookie.get('list364_selectday')
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        consulting: [],
        consultingType: '',
        date: '',
      },
    };
  },
  methods: {
    changeTable(value) {
      this.form.consultingType = ''
      for (const data of value) {
        console.log(data)
        this.form.consultingType += (data.input1 + ' ')
      }
    }
  },
  computed: {
    projectId () {
      return parseInt(this.$route.params.proj_id)
    }
  },
};
</script>

<style scoped lang="scss">
</style>
